import { BaseAPI } from "../../BaseAPI";
import * as environment from '../../../config/environment';

class EdevletApi extends BaseAPI {
  

  constructor () {
    const baseUrl = environment.API_URL + "Edevlet";
    super(baseUrl);
  }


  getAccessCode( code: any){
    return this.get("callback",{params:{code:code}});
  }

}
export default new EdevletApi();
